export default __webpack_public_path__ + "effcf65dbcd14b00114220f6ec1e5d3b.jpg";